import Checkbox from "../../../../common/Checkbox";
import Icon from "../../../../common/Icon";
import ElementsTableWrapper from "../ElementsTableWrapper";

import { TableRow, TableCell, Pill } from "../../../../../constants/Styles";
import * as styledElements from "./LoadingTableStyles";

const NUM_COLUMNS = 12;

export default function LoadingTable({
  tableLength,
  isAdminOrEngineer,
}: {
  tableLength: number;
  isAdminOrEngineer: boolean;
}) {
  return (
    <ElementsTableWrapper>
      {Array.from({ length: tableLength }, (_, index) => (
        <TableRow key={`loading-table-row${index}`} style={{ height: "64px" }}>
          {Array.from({ length: NUM_COLUMNS }, (_, index) => (
            <TableCell key={`pill-cell-${index}`}>
              <Pill />
            </TableCell>
          ))}
          <TableCell>
            <styledElements.FakeCheckbox>
              <Checkbox checked={false} disabled={true} />
            </styledElements.FakeCheckbox>
          </TableCell>
          <TableCell>
            <styledElements.EditIcon>
              <Icon src="/icons/pencil.svg" alt="edit" iconDimension={20} />
              <Icon src="/icons/trash.svg" alt="delete" iconDimension={20} />
            </styledElements.EditIcon>
          </TableCell>
          {isAdminOrEngineer && (
            <TableCell>
              <styledElements.FakeCheckbox>
                <Checkbox checked={false} disabled={true} />
              </styledElements.FakeCheckbox>
            </TableCell>
          )}
        </TableRow>
      ))}
    </ElementsTableWrapper>
  );
}
